export const getLabel = (path: string) => `${path[0].toUpperCase()}${path.replace(/-/g, ' ').slice(1)}`;
